import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { to: "/", label: "Acasă", testid: "nav-link-home" },
  { to: "/proiecte", label: "Proiecte", testid: "nav-link-projects" },
  { to: "/bushido-vs-bullying", label: "Anti-Bullying", testid: "nav-link-bushido" },
  { to: "/redirectioneaza-3-5", label: "3,5%", testid: "nav-link-redirect" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="group flex items-center gap-3">
    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-neon font-display text-sm font-black text-canvas transition-transform duration-300 group-hover:rotate-6">
      A&O
    </span>
    <span className="leading-tight">
      <span className="block font-display text-[11px] font-bold uppercase tracking-[0.18em] text-white">
        Art & Outdoor
      </span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-neon">
        Asociație · ONG
      </span>
    </span>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-canvas/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-12">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-mono text-xs font-bold uppercase tracking-[0.22em] transition-colors duration-300 ${
                  isActive ? "text-neon" : "text-neutral-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/rise27"
            data-testid="nav-cta-rise27"
            className="group flex items-center gap-1.5 rounded-full bg-neon px-5 py-2.5 font-display text-[11px] font-bold uppercase tracking-wider text-canvas transition-colors duration-300 hover:bg-white"
          >
            RISE 27'
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 text-white md:hidden"
          aria-label="Meniu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-white/10 bg-canvas/95 md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-xl px-4 py-3 font-mono text-sm font-bold uppercase tracking-[0.2em] transition-colors ${
                      isActive ? "bg-white/5 text-neon" : "text-neutral-300"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/rise27"
                data-testid="nav-cta-rise27-mobile"
                onClick={() => setOpen(false)}
                className="mt-3 flex items-center justify-center gap-2 rounded-full bg-neon px-5 py-3 font-display text-xs font-bold uppercase tracking-wider text-canvas"
              >
                RISE 27' <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
